import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
import './Layout.css';

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <Link to="/" className="sidebar-brand">
            <Logo size={36} />
            <span>Musteribul</span>
          </Link>
          <p>{user?.username}</p>
        </div>

        <nav className="sidebar-nav">
          <Link to="/">
            <i className="icon">📊</i> Dashboard
          </Link>
          <Link to="/businesses">
            <i className="icon">🏢</i> İşletmeler
          </Link>
          <Link to="/campaigns">
            <i className="icon">📢</i> Kampanyalar
          </Link>
          <Link to="/settings">
            <i className="icon">⚙️</i> Ayarlar
          </Link>
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          Çıkış Yap
        </button>
      </aside>

      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

export default Layout;